// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-js" + "-" + "c541078db0e65984c493" + ".js";
};